export var CallEventType;
(function (CallEventType) {
    CallEventType["ICE_CANDIDATES_FOUND"] = "IceCandidatesFoundEvent";
    CallEventType["CALL_ANSWERED"] = "CallAnsweredEvent";
    CallEventType["CALL_UPDATE"] = "CallUpdatedEvent";
    CallEventType["CALL_ENDED"] = "CallEndedEvent";
    CallEventType["CALL_REJECTED"] = "CallRejectedEvent";
    CallEventType["CALL_CANCELLED"] = "CallCancelledEvent";
    CallEventType["CALL_RINGING"] = "CallRingingEvent";
    CallEventType["CALL_CREATED"] = "CallCreatedEvent";
})(CallEventType || (CallEventType = {}));
export var States;
(function (States) {
    States["CALL"] = "CREATE";
    States["RINGING"] = "RINGING";
    States["REJECT"] = "REJECT";
    States["CANCEL"] = "CANCEL";
    States["HANGUP"] = "HANGUP";
    States["ANSWER"] = "ANSWER";
    States["ESTABLISHED"] = "ESTABLISHED";
    States["FAIL"] = "FAIL";
    States["CLOSE"] = "CLOSE";
})(States || (States = {}));
//# sourceMappingURL=model.js.map